/**
 * Constantes do sistema
 * 
 * Este arquivo contém constantes globais utilizadas em toda a aplicação.
 */

// Constantes legadas (n8n) removidas na migração para Supabase.

// Status de conta permitidos
export const ACCOUNT_STATUS = {
  ACTIVE: 'ATIVO',
  INACTIVE: 'INATIVO',
  SUSPENDED: 'SUSPENSO'
};

// Níveis de acesso
export const ACCESS_LEVELS = {
  BASIC: 1,      // Usuário Básico
  ADVANCED: 2,   // Usuário Avançado
  SUPERVISOR: 3, // Supervisor
  MANAGER: 4,    // Gerente
  ADMIN: 5       // Administrador
};

// Planos de conta
export const ACCOUNT_PLANS = {
  INTERNAL: 'INTERNO',
  TEST: 'TESTE',
  BETA: 'BETA',
  BETA2: 'BETA2',
  CUSTOM: 'PERSONALIZADO'
};

// Endpoints do Backend (centralizados)
// BACKEND_NODE_URL: parametrizado via Vite
// Padrão: https://api.halo.ia.br (produção)
// BACKEND_N8N_URL: n8n legado (apenas até migrarmos todos os endpoints)
export const BACKEND_NODE_URL = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_BACKEND_URL)
  ? import.meta.env.VITE_BACKEND_URL
  : 'https://api.halo.ia.br';
const BACKEND_N8N_URL = 'https://n8n.astrodev.com.br/webhook';

export const API_ENDPOINTS = {
  // Conexões (WhatsApp/Telegram)
  // Novo backend Node (apenas create por enquanto)
  CONNECTIONS_CREATE: `${BACKEND_NODE_URL}/connections/create`,
  /** WhatsApp Business Platform (Cloud API / coexistência Meta) */
  CONNECTIONS_CREATE_META_CLOUD: `${BACKEND_NODE_URL}/connections/create-meta-cloud`,
  // Excluir conexão (via backend Node)
  CONNECTIONS_DELETE: `${BACKEND_NODE_URL}/connections/delete`,
  // Arquivar conexão (soft-delete: status INATIVA)
  CONNECTIONS_ARCHIVE: `${BACKEND_NODE_URL}/connections/archive`,
  // Agora QR pelo backend Node (usa token salvo da instância)
  CONNECTIONS_QR: `${BACKEND_NODE_URL}/connections/connect`,
  CONNECTIONS_MARK_CONNECTED: `${BACKEND_NODE_URL}/connections/mark-connected`,
  // Enviar texto via Uazapi (proxy backend)
  CONNECTIONS_SEND_TEXT: `${BACKEND_NODE_URL}/connections/send-text`,
  // Enviar mídia (imagem, vídeo, documento, áudio/ptt) via Uazapi (proxy backend)
  CONNECTIONS_SEND_MEDIA: `${BACKEND_NODE_URL}/connections/send-media`,
  // Status real das conexões (consulta Uazapi via backend)
  CONNECTIONS_STATUS: `${BACKEND_NODE_URL}/connections/status`,
  /** GET/PUT — credenciais WhatsApp Cloud (Meta) por empresa */
  COMPANY_WHATSAPP_CLOUD: `${BACKEND_NODE_URL}/api/company/whatsapp-cloud`,
  // Detalhes (perfil/status seguro) - construir URL: `${CONNECTIONS_DETAILS_BASE}/${id}/details`
  CONNECTIONS_DETAILS_BASE: `${BACKEND_NODE_URL}/connections`,
  // Atualizar nome de perfil do WhatsApp - construir URL: `${CONNECTIONS_PROFILE_NAME}/${id}`
  CONNECTIONS_PROFILE_NAME: `${BACKEND_NODE_URL}/connections/profile-name`,
  // Alterar imagem do perfil do WhatsApp
  CONNECTIONS_PROFILE_IMAGE: `${BACKEND_NODE_URL}/connections/profile-image`,
  // Mídia (reprocessar imagem/vídeo/áudio para Storage)
  MEDIA_REPROCESS: `${BACKEND_NODE_URL}/media/reprocess`,
  // Gerar URL assinada para acessar arquivo no Storage
  MEDIA_SIGNED_URL: `${BACKEND_NODE_URL}/media/signed-url`,
  // Agentes (integração com Uazapi via backend)
  AGENTS_SYNC: `${BACKEND_NODE_URL}/agents/sync`,
  AGENTS_APPLY_SETTINGS: `${BACKEND_NODE_URL}/agents/apply-settings`,
  AGENTS_DELETE: `${BACKEND_NODE_URL}/agents/delete`,
  // Halo Nano (modelo 'nano')
  AGENTS_NANO_UPDATE: `${BACKEND_NODE_URL}/agents/tools/nano/update`,
  AGENTS_NANO_UPSERT: `${BACKEND_NODE_URL}/agents/tools/nano/upsert`,
  // Halo Pro (modelo 'pro' - desativado por enquanto)
  AGENTS_PRO_UPDATE: `${BACKEND_NODE_URL}/agents/tools/pro/update`,
  AGENTS_PRO_UPSERT: `${BACKEND_NODE_URL}/agents/tools/pro/upsert`,
  // Legacy (manter para compatibilidade)
  AGENTS_TOOLS_UPSERT: `${BACKEND_NODE_URL}/agents/tools/upsert`,
  AGENTS_TOOLS_UPDATE: `${BACKEND_NODE_URL}/agents/tools/update-instructions`,
  AGENTS_TOOLS_UPDATE_MAPPING: `${BACKEND_NODE_URL}/agents/tools/update-mapping`,
  // Halo Chat (conversas internas com agentes)
  HALO_CHAT: `${BACKEND_NODE_URL}/api/halo/chat`,
  HALO_TEST: `${BACKEND_NODE_URL}/api/halo/test`,
  // AI Automation (Geração de prompts)
  AI_GENERATE_PROMPT: `${BACKEND_NODE_URL}/api/ai-automation/generate-prompt`,
  AI_IMPROVE_PROMPT: `${BACKEND_NODE_URL}/api/ai-automation/improve-prompt`,
  AI_GET_TEMPLATE: `${BACKEND_NODE_URL}/api/ai-automation/templates`,
  // Produtos (Halo Tools - Step 3)
  AGENTS_TOOLS_PRODUCTS_ADD: `${BACKEND_NODE_URL}/agents/tools/products/add`,
  AGENTS_TOOLS_PRODUCTS_BULK_UPSERT: `${BACKEND_NODE_URL}/agents/tools/products/bulk-upsert`,
  AGENTS_TOOLS_PRODUCTS_LIST: `${BACKEND_NODE_URL}/agents/tools/products/list`,
  // Formulário (Halo Tools - Step 3)
  AGENTS_TOOLS_FORMS_ADD: `${BACKEND_NODE_URL}/agents/tools/forms/add`,
  AGENTS_TOOLS_FORMS_BULK_UPSERT: `${BACKEND_NODE_URL}/agents/tools/forms/bulk-upsert`,
  AGENTS_TOOLS_FORMS_LIST: `${BACKEND_NODE_URL}/agents/tools/forms/list`,
  // Uazapi Knowledge (direto na API pública da Uazapi)
  
  // ===== ENDPOINTS OTIMIZADOS (Cache Compartilhado) =====
  // Reduzem uso de PostgREST Egress em ~93%
  OPTIMIZED_CONNECTIONS: `${BACKEND_NODE_URL}/api/optimized/connections`,
  OPTIMIZED_CONVERSATIONS: `${BACKEND_NODE_URL}/api/optimized/conversations`,
  OPTIMIZED_MESSAGES: `${BACKEND_NODE_URL}/api/optimized/messages`,
  OPTIMIZED_CONTACTS_SEARCH: `${BACKEND_NODE_URL}/api/optimized/contacts/search`,
  OPTIMIZED_CACHE_STATS: `${BACKEND_NODE_URL}/api/optimized/cache/stats`,
  OPTIMIZED_CACHE_INVALIDATE: `${BACKEND_NODE_URL}/api/optimized/cache/invalidate`,
  
  // ===== CRM FOLLOW-UP =====
  CRM_FOLLOWUP_RULES: `${BACKEND_NODE_URL}/api/crm-followup/rules`,
  CRM_CARD_MOVED: `${BACKEND_NODE_URL}/api/crm-followup/card-moved`,
  
  // ===== LEAD DISTRIBUTION =====
  LEAD_DISTRIBUTION: `${BACKEND_NODE_URL}/api/lead-distribution`,
  
  // ===== LEAD FORWARD =====
  LEAD_FORWARD: `${BACKEND_NODE_URL}/api/lead-forward`,
};

// REMOVIDO POR SEGURANÇA: UAZAPI_URL, UAZAPI_TOKEN, UAZAPI_ENDPOINTS e OPENAI_API_KEY
// Essas chaves NÃO devem estar no frontend (bundle público).
// Todas as chamadas à Uazapi e OpenAI devem passar pelo backend (proxy).
